import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Github, Mail, FileText } from 'lucide-react'

export default function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t bg-background">
      <div className="container mx-auto px-4 py-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Brand */}
          <div className="space-y-2">
            <h3 className="font-bold text-lg">QuantQuack</h3>
            <p className="text-sm text-muted-foreground">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Links */}
          <div className="space-y-2">
            <h4 className="font-semibold text-sm">{t('footer.product')}</h4>
            <ul className="space-y-1 text-sm">
              <li>
                <Link to="/scripts" className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('nav.scripts')}
                </Link>
              </li>
              <li>
                <Link to="/datasets" className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('nav.datasets')}
                </Link>
              </li>
              <li>
                <Link to="/jobs" className="text-muted-foreground hover:text-foreground transition-colors">
                  {t('nav.jobs')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="space-y-2">
            <h4 className="font-semibold text-sm">{t('footer.resources')}</h4>
            <ul className="space-y-1 text-sm">
              <li>
                <a
                  href="https://www.quantquack.xyz/dsl-guide"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1"
                >
                  <FileText className="w-3 h-3" />
                  {t('footer.documentation')}
                </a>
              </li>
              <li>
                <a
                  href="https://www.quantquack.xyz/api-reference"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t('footer.api')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-2">
            <h4 className="font-semibold text-sm">{t('footer.support')}</h4>
            <ul className="space-y-1 text-sm">
              <li>
                <a
                  href="mailto:support@quantquack.xyz"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1"
                >
                  <Mail className="w-3 h-3" />
                  {t('footer.contact')}
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/quantquack"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1"
                >
                  <Github className="w-3 h-3" />
                  {t('footer.github')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="text-xs text-muted-foreground">
            © {currentYear} QuantQuack. {t('footer.rights')}
          </p>
          <div className="flex gap-4 text-xs text-muted-foreground">
            <Link to="/settings" className="hover:text-foreground transition-colors">
              {t('nav.settings')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
